import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders, HttpErrorResponse,HttpResponse } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-control': 'no-cache',
      'Expires': '0',
      'Pragma': 'no-cache',
      'Access-Control-Allow-Origin': '*',
     
    })
};

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http:HttpClient) { 

  }
  public Get(url:string) {  
    //console.log(url);  
    return this.http.get<any>(url,httpOptions).pipe();
  }

  public Post(url:string,input_data: any)
  {
    //console.log(url);
    //console.log(input_data);
    return this.http.post<any>(url, input_data,httpOptions)
    .pipe();
  }
  public Put(url:string,input_data: any)
  {
    //console.log(url);
    //console.log(input_data);
    return this.http.put<any>(url, input_data,httpOptions)
    .pipe();
  }
  public delete(url:string)
  {
    //console.log(url);
    return this.http.delete<any>(url, httpOptions)
    .pipe();
  }
  
}
